/*
 * @Description: using in Upload Modal
 * @Author: Jack Deng
 * @Date: 2021-03-09 15:05:13
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-22 15:14:13
 * @FilePath: /unifyxp-v2-store-portal/src/components/Upload/PictureCard/index.tsx
 */

import React from 'react';
import classname from 'classnames';
import _ from 'lodash';
import { Progress } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { MediaFile } from '@/src/types/common/media';

import styles from './style.module.less';

type Props = {
  checked: boolean;
  loading: boolean;
  file: MediaFile;
  percent: number;
  onClick: (file: MediaFile) => void;
};

function PictureCard({ checked, loading, file, onClick, percent }: Props) {
  const imageUrl = _.get(file, 'url');
  return (
    <div
      className={styles.container}
      style={{
        border: checked ? 'solid 3px #38c568' : undefined,
      }}
      onClick={onClick.bind(this, file)}>
      <div className={classname(styles.check, { [styles.checked]: checked })}>
        <CheckOutlined
          style={{
            color: '#fff',
            width: '13px',
            height: '13px',
            fontSize: '14px',
            fontWeight: 600,
          }}
        />
      </div>
      {loading ? (
        <div className={styles.progress}>
          <Progress
            type='circle'
            percent={percent}
            width={30}
            showInfo={false}
          />
        </div>
      ) : (
        <div
          className={styles.image}
          style={{
            backgroundImage: `url('${imageUrl}')`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
          }}
        />
      )}
    </div>
  );
}

export default PictureCard;
